import { types } from "../types/types";
import { fetchConToken } from "../helpers/fetch";
import { handleErrorApi } from "../helpers/randoms";
import { startAlerta } from "./ui/alertas";
import { startSpinner, finishSpinner } from "./ui/spinner";

export const reportesTraerStart = () => ({ type: types.reportesTraerStart });
export const reportesLimpiar = () => ({ type: types.reportesLimpiar });
export const reportesTraerError = (error) => ({ type: types.reportesTraerError,payload: error});
export const reportesTraerSuccess = (payload) => {
    return {
        type: types.reportesTraerSuccess,
        payload: payload
    }
}
export const fetchReportes = () => {
    return async (dispatch) => {
        dispatch(reportesTraerStart());
        const response = await fetchConToken(`reportes`);
        if (!response.ok) {
            dispatch(reportesTraerError(response.statusText));
            throw Error(response.statusText);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const lista = await response.json();
            if (lista.length>0) {
                dispatch(reportesTraerSuccess(lista));
            }
        }
    };
};
export const fetchReportesTodos = ()=>{
    return async (dispatch) => {
        dispatch(reportesTraerStart());
        const response = await fetchConToken(`reportes/ObtenerTodos`);
        if (!response.ok) {
            dispatch(reportesTraerError(response.statusText));
            throw Error(response.statusText);
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
            const lista = await response.json();
            if (lista.length>0) {
                dispatch(reportesTraerSuccess(lista));
            }
        }
    };
}
export const setReporte = (idReporte,DescripcionReporte,idRol,idArea, idCentro)=>async(dispatch)=>{
    dispatch(startSpinner());
    
    try{
        let data = {
            descripcionReporte : DescripcionReporte,
            reportesAreas : idArea,
            reportesRoles : idRol,
            reportesCentrosMedicos: idCentro
        }
        const response = await fetchConToken(`ReportesPorAreaYRol/${idReporte}`,data,"PUT");
        const body= await response.json(); 

        if(response.ok){
            dispatch(startAlerta("Actualizado", 'success', 'Comando Exitoso'));
            dispatch(finishSpinner());
            dispatch(fetchReportesTodos());
        }else{
            throw body
        }
    }catch(error){
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al actualizar.", "Ha ocurrido un error. Intente nuevamente")
    }
}
export const buscarReporte = (text) => dispatch => {
    dispatch({
        type:types.reportesBuscar,
        payload:text
    });
}

export const generateExcelReportesArea = () => async (dispatch) => {
    dispatch(startSpinner());
    try {
      const response = await fetchConToken('ReportesPorAreaYRol/GenerarExcel');
      const body = await response.blob();
      if (response.ok) {
        dispatch(finishSpinner());
  
        let url = window.URL.createObjectURL(body);
        let a = document.createElement('a');
        a.href = url;
        a.download = `Reportes por Area y Rol.xlsx`;
        a.click();
  
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al traer el excel",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };

  export const generatePDFReportesArea = () => async (dispatch) => {
    dispatch(startSpinner());
    try {
      const response = await fetchConToken('ReportesPorAreaYRol/GenerarPDF');
      const body = await response.blob();
      if (response.ok) {
        dispatch(finishSpinner());
  
        window.open(URL.createObjectURL(body));
  
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        "Error al traer el pdf",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
  };